import { render } from "./MainNav.vue?vue&type=template&id=6d2e86cf&scoped=true&bindings={\"areaClientiLink\":\"props\",\"desktop\":\"props\",\"showMenu\":\"options\",\"mainMenu\":\"options\",\"menuInline\":\"options\",\"menuFull\":\"options\",\"getLabel\":\"options\",\"toggleMenu\":\"options\",\"getChildren\":\"options\",\"sortMenu\":\"options\"}"
import script from "./MainNav.vue?vue&type=script&lang=js"
export * from "./MainNav.vue?vue&type=script&lang=js"

import "./MainNav.vue?vue&type=style&index=0&id=6d2e86cf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d2e86cf"

export default script